module.exports = __webpack_public_path__ + "static/media/magnifying-glass~wfjKNiyd.6bf6c057.svg";